import React, { useState } from "react";
import useCoupon from "./useCoupon";
import EditImg from "../../images/SideBar/Edit";
import Loader from "../../components/Loader";
import CommonDataGrid from "../../components/CommonDataGrid";
import Button from "../../components/Botton";
import { Toaster } from "react-hot-toast";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { TextField } from "@mui/material";
import DeleteImg from "../../images/SideBar/Delete";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import convertMongoDateToNormalDate from "./dateSanitizer";
import { getSortByTimeButtonText } from "../../util/getSortByTimeText";
import { hasPermission } from "../../utils/permissions";
import { useAppSelector } from "../../store/hooks";
import { selectUser } from "../../store/slices/authSlice";
import { getDeleteConfirmationMessage } from "../../utils/pagePermissions";

const Coupon: React.FC = () => {
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);
  const canEdit = hasPermission(user, "coupon", "update");
  const canAdd = hasPermission(user, "coupon", "create");
  const canDelete = hasPermission(user, "coupon", "delete");

  const columns: GridColDef[] = [
    {
      field: "code",
      headerName: "Coupon Code",
      align: "center",
      headerAlign: "center",
      // flex: 0.5,
      width: 120,
      filterable: true,
    },
    {
      field: "discountType",
      headerName: "Discount Type",
      align: "center",
      headerAlign: "center",
      // flex: 0.5,
      width: 120,
      type: "singleSelect",
      valueOptions: ['PERCENTAGE', 'FIXED'],
      filterable: true,
    },
    {
      field: "type",
      headerName: "Coupon category",
      align: "center",
      headerAlign: "center",
      // flex: 0.5,
      filterable: true,
      valueGetter: (params: any) => {
        return params?.name
      }


    },
    {
      field: "discountValue",
      headerName: "Discount Value",
      align: "center",
      headerAlign: "center",
      // flex: 0.5,
      type: "number",
      filterable: true,
    },
    {
      field: "isActive",
      headerName: "Active",
      align: "center",
      headerAlign: "center",
      // flex: 0.3,
      width: 50,
      type: "boolean",
      filterable: true,
    },
    {
      field: "isForNewUsersOnly",
      headerName: "New users only",
      align: "center",
      headerAlign: "center",
      // flex: 0.3,
      width: 80,
      type: "boolean",
      filterable: true,
    },
    {
      field: "maxDiscountAmount",
      headerName: "Max Discount Amount",
      align: "center",
      headerAlign: "center",
      // flex: 0.3,
      type: "number",
      filterable: true,
    },
    {
      field: "assignmentType",
      headerName: "Assignment",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      type: "singleSelect",
      valueOptions: ['everyone', 'specific'],
      filterable: true,
    },
    {
      field: "usedCount",
      headerName: "Use Count",
      align: "center",
      headerAlign: "center",
      flex: 0.3,
      type: "number",
      filterable: true,
    },
    {
      field: "validFrom",
      headerName: "Valid From",
      align: "center",
      headerAlign: "center",
      // flex: 0.3,
      width: 80,
      type: "date",
      filterable: true,
      valueGetter: (params: any) => {
        return new Date(params);
      }
    },
    {
      field: "validUntil",
      headerName: "Valid Until",
      align: "center",
      headerAlign: "center",
      width: 80,
      // flex: 0.3,
      type: "date",
      filterable: true,
      valueGetter: (params: any) => {
        return new Date(params);
      }
    },
  ];

  if (canEdit || canDelete) {
    columns.push({
      field: "Actions",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 0.8,
      renderCell: (params: any) => (
        <div className="flex h-full items-center justify-center gap-3">
          {canEdit && (
            <button
              onClick={() => navigate(`/${'edit-coupon'}/${params.row._id}`)}
              className="text-fontColor hover:text-primary-2"
            >
              <EditImg />
            </button>
          )}
          {canDelete && (
            <button
              onClick={() => openDeleteModal(params.row._id)}
              className="text-fontColor hover:text-red-500"
            >
              <DeleteImg />
            </button>
          )}
        </div>
      ),
    });
  }

  const {
    fetchAllCoupons, handleDelete, handleEdit, selectedCouponId, setSelectedCouponId, loading, setLoading, handleAdd, couponData, searchQuery, setSearchQuery, setFilterModel, setSortingModel, rowCount, paginationModel, setPaginationModel, handleSortByTime, timeSortOrder

  } = useCoupon(columns);

  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open state
  const [testquestionToDelete, setTestQuestionToDelete] = useState<
    string | null
  >(null);

  const openDeleteModal = (id: string) => {
    setTestQuestionToDelete(id);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    if (testquestionToDelete) {
      handleDelete(testquestionToDelete);
      setIsModalOpen(false);
    }
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setTestQuestionToDelete(null);
  };

  return (
    <div className="mx-auto p-4">
      {loading && <Loader />}
      {selectedCouponId ? (
        // <EditTestQuestionIndex testQuestionId={selectedTestQuestionId} setSelectedTestQuestionId={setSelectedTestQuestionId}  />
        <></>
      ) : (
        <div className=" space-y-4 mt-4 bg-white p-4 rounded-b-lg shadow-md ">
          <div className="flex justify-between items-center gap-4 mr-1 mb-4">
            <TextField
              fullWidth
              variant="outlined"
              label="Search"
              placeholder="Search By"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              size="small"
              sx={{ maxWidth: '400px' }}
            />
            <div className="flex gap-3">
              <Button
                onClick={handleSortByTime}
                className="py-1.5 px-9 rounded"
                children={getSortByTimeButtonText(timeSortOrder)}
                type="button"
              />
              {canAdd && (
                <Button
                  onClick={handleAdd}
                  className="py-1.5 px-9 rounded"
                  children="Add Coupon"
                  type="button"
                />
              )}
            </div>
          </div>
          <CommonDataGrid
            id='ebook'
            rows={couponData}
            columns={columns}
            loading={loading}
            showConfirmation={false}
            confirmationMessage={""}
            setFilterModel={setFilterModel}
            setSortingModel={setSortingModel}
            //Pagination
            paginationMode="server"
            rowCount={rowCount}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            onCancelDelete={() => { }}
            onConfirmDelete={() => { }}
            toolbarProps={{ toolbar: { showQuickFilter: true } }}
          />
        </div>
      )}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
        message={getDeleteConfirmationMessage("coupon")}
      />
      <Toaster />
    </div>
  );
};

export default Coupon;
